/**
 * Shared GLSL snippets for the Sprint 2 surface shaders (Sun, Milky Way).
 */

/** 3D value noise and a small fBm (Inigo Quilez style hash); cheap enough for full-screen use at 3 octaves. */
export const NOISE_GLSL = /* glsl */ `
  float zfHash(vec3 p) {
    p = fract(p * 0.3183099 + 0.1);
    p *= 17.0;
    return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
  }
  float zfNoise(vec3 x) {
    vec3 i = floor(x);
    vec3 f = fract(x);
    f = f * f * (3.0 - 2.0 * f);
    return mix(
      mix(mix(zfHash(i + vec3(0, 0, 0)), zfHash(i + vec3(1, 0, 0)), f.x),
          mix(zfHash(i + vec3(0, 1, 0)), zfHash(i + vec3(1, 1, 0)), f.x), f.y),
      mix(mix(zfHash(i + vec3(0, 0, 1)), zfHash(i + vec3(1, 0, 1)), f.x),
          mix(zfHash(i + vec3(0, 1, 1)), zfHash(i + vec3(1, 1, 1)), f.x), f.y),
      f.z);
  }
  float zfFbm(vec3 p) {
    float v = 0.0;
    float a = 0.5;
    for (int i = 0; i < 3; i++) {
      v += a * zfNoise(p);
      p *= 2.03;
      a *= 0.5;
    }
    return v;
  }
`;
